// extracted by mini-css-extract-plugin
export default {"back_icon":"styles_back_icon__iiyy+"};